/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ApproveAllSkillSuggestionsRequestBody = {
  /**
   * Optional suggestion IDs to approve. Omitted or empty approves every currently open suggestion.
   */
  suggestionIds?: Array<string> | undefined;
};

/** @internal */
export type ApproveAllSkillSuggestionsRequestBody$Outbound = {
  suggestion_ids?: Array<string> | undefined;
};

/** @internal */
export const ApproveAllSkillSuggestionsRequestBody$outboundSchema:
  z.ZodMiniType<
    ApproveAllSkillSuggestionsRequestBody$Outbound,
    ApproveAllSkillSuggestionsRequestBody
  > = z.pipe(
    z.object({
      suggestionIds: z.optional(z.array(z.string())),
    }),
    z.transform((v) => {
      return remap$(v, {
        suggestionIds: "suggestion_ids",
      });
    }),
  );

export function approveAllSkillSuggestionsRequestBodyToJSON(
  approveAllSkillSuggestionsRequestBody: ApproveAllSkillSuggestionsRequestBody,
): string {
  return JSON.stringify(
    ApproveAllSkillSuggestionsRequestBody$outboundSchema.parse(
      approveAllSkillSuggestionsRequestBody,
    ),
  );
}
